var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeftArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 7 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M.307 4.758a1.05 1.05 0 0 0 0 1.484l4.451 4.45A1.05 1.05 0 1 0 6.242 9.21L2.532 5.5l3.71-3.71A1.05 1.05 0 0 0 4.758.308l-4.45 4.45z",
  clipRule: "evenodd"
})));
export default SvgLeftArrow;